var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVipIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.394 2.143l-3.26 3.296 3.26 3.296c.485.49.485 1.285 0 1.775a1.23 1.23 0 01-1.755 0l-3.26-3.296-3.26 3.296a1.23 1.23 0 01-1.755 0 1.265 1.265 0 010-1.775l3.26-3.296-3.26-3.296a1.265 1.265 0 010-1.776c.484-.49 1.27-.49 1.755 0l3.26 3.297L8.639.367c.485-.49 1.27-.49 1.755 0 .485.49.485 1.285 0 1.776z",
    fill: "var(--text-secondary, #95A4AC)"
  })));
}
export default SvgVipIconClose;